import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@softline/core';
import { ActivatedRoute } from '@angular/router';
import * as RegistrationStore from '../../store/registration.store';
import { SOFTLINE_FEATURE_REGISTRATION } from '../../registration.shared';
import {MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR} from '@softline/ui-core';
import {CommonModule} from '@angular/common';

import { LoadingSpinnerComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-registration-confirmation',
    imports: [CommonModule,
    LoadingSpinnerComponent,
    TranslatePipe],
    templateUrl: './registration-confirmation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./registration-confirmation.component.css']
})
export class RegistrationConfirmationComponent implements OnInit {

  confirming$ = this.store.observe(SOFTLINE_FEATURE_REGISTRATION, RegistrationStore.getters.confirming);
  confirmed$ = this.store.observe(SOFTLINE_FEATURE_REGISTRATION, RegistrationStore.getters.confirmed);

  username?: string;

  constructor(private store: Store, private route: ActivatedRoute) { }

  async ngOnInit(): Promise<void> {
    try {
      this.username = this.route.snapshot.queryParams['username'];
      const hash = this.route.snapshot.queryParams['hash'];
      const params = {username: this.username, hash};
      const result = await this.store.dispatch(SOFTLINE_FEATURE_REGISTRATION, RegistrationStore.actions.confirm, params);

      if (!result) {
        await this.showError(null);
      } else {
        const message = {
          title: '#PORTAL_REGISTRATION.CONFIRM.MESSAGES.SUCCESS.TITLE',
          message: '#PORTAL_REGISTRATION.CONFIRM.MESSAGES.SUCCESS.MESSAGE'
        };
        await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.success, message);
      }
    } catch (e) {
      await this.showError(e);
      this.store.commit(SOFTLINE_FEATURE_REGISTRATION, RegistrationStore.mutations.setConfirmed, false);
    }
  }

  private async showError(e: any): Promise<void> {
    const message = {
      title: '#PORTAL_REGISTRATION.CONFIRM.MESSAGES.FAILURE',
      message: e.error.error.errors[0].message ?? 'Unbekannter Fehler'
    };
    await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, message);
  }
}
